// hooks/useLearnerTrainings.js
import { getNameList } from "PlatForms/OrgLMS/Services/LearnerService/trainingService";
import { getLearnerTrainings } from "PlatForms/OrgLMS/Services/LearnerService/trainingService";
import { useEffect, useState } from "react";

const useLearnerTrainings = (learnerUserId, token, completed = false) => {
  const [trainingData, setTrainingData] = useState([]);
  const [nameList, setNameListData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrainings = async () => {
      try {
        const data = await getLearnerTrainings(learnerUserId, token, completed);
        setTrainingData(data);
      } catch (error) {
        console.error("Fetching error:", error);
      } finally {
        setLoading(false);
      }
    };

    if (learnerUserId && token) fetchTrainings();
  }, [learnerUserId, token, completed]);
console.log(".,,,,,,,,,,,",learnerUserId);
  useEffect(() => {
    const fetchNameList = async () => {
      try {
        const data = await getNameList(learnerUserId, token);
        setNameListData(data);
      } catch (error) {
        console.error("Fetching error:", error);
      } finally {
        setLoading(false);
      }
    };

    if (learnerUserId && token) fetchNameList();
  }, [learnerUserId, token]);

  return { trainingData, loading, nameList };
};

export default useLearnerTrainings;
